export default [
  {
    path: '/perdas-aic',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Perdas AIC Histórico',
        path: 'historico',
        component: () => import('@/views/perdasAic/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Perdas AIC' }]
        }
      },
      {
        name: 'Perdas AIC Adicionar',
        path: 'edit',
        component: () => import('@/views/perdasAic/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Perdas AIC', path: '/perdas-aic/historico' },
            { name: 'Adicionar' }
          ]
        }
      },
      {
        name: 'Perdas AIC Editar',
        path: 'edit/:id',
        component: () => import('@/views/perdasAic/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Perdas AIC', path: '/perdas-aic/historico' },
            { name: 'Editar' }
          ]
        }
      }
    ]
  }
];
